import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";

// The one status pill for the whole app. Tones are semantic, not colours: the
// caller resolves its domain status into a tone (see the *-status-display.ts
// mappers) and this component owns the look. Deliberately dumb — it never
// inspects labels, so renaming Thai copy can't silently change a colour.
export type StatusTone =
  | "draft"
  | "pending"
  | "waiting_review"
  | "completed"
  | "revision"
  | "special_revision"
  | "inert";

export type StatusBadgeSize = "sm" | "md";

const TONE_CLASS: Record<StatusTone, string> = {
  draft: "app-status-badge-draft",
  pending: "app-status-badge-pending",
  waiting_review: "app-status-badge-waiting-review",
  completed: "app-status-badge-completed",
  revision: "app-status-badge-revision",
  special_revision: "app-status-badge-special-revision",
  inert: "app-status-badge-inert",
};

@Component({
  selector: "app-status-badge",
  templateUrl: "./status-badge.component.html",
  styleUrls: ["./status-badge.component.scss"],
  imports: [NgClass],
})
export class StatusBadgeComponent {
  @Input() tone: StatusTone = "pending";
  @Input() label: string | null = null;
  @Input() size: StatusBadgeSize = "sm";
  /**
   * Optional hover text explaining WHY the row is in this state. Rendered as the native
   * `title` attribute — still "dumb": the caller composes the sentence, the badge never
   * derives it from the label. Omit it and no attribute is emitted at all.
   */
  @Input() tooltip: string | null = null;

  get displayLabel(): string {
    const label = String(this.label ?? "").trim();

    return label !== "" ? label : "-";
  }

  get tooltipText(): string | null {
    const tooltip = String(this.tooltip ?? "").trim();

    return tooltip !== "" ? tooltip : null;
  }

  get toneClass(): string {
    return TONE_CLASS[this.tone] ?? TONE_CLASS.pending;
  }

  get sizeClass(): string {
    return this.size === "md"
      ? "app-status-badge-md"
      : "app-status-badge-sm";
  }
}
